import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/negligence',
    name: 'Medical Negligence',
    component: () => import(/* webpackChunkName: "about" */ '../views/Negligence.vue'),
    meta: {
      auth: true,
      title: 'Cases map'
    }
  },
  {
    path: '/policy',
    name: 'Policies and Measures',
    component: () => import('../views/Policy.vue'),
    meta: {
      auth: true,
      title: 'Policies and measures'
    }
  },
  {
    path: '/clinics',
    name: 'Clinics in HK',
    component: () => import('../views/Clinics.vue'),
    meta: {
      auth: true,
      title: 'Clinics map'
    }
  }
]

const router = new VueRouter({
  routes
})

export default router
